














import { computed, defineComponent, getCurrentInstance } from '@vue/composition-api';
import ActionSheet from '@/renderer/components/mobile/base/ActionSheet/index.vue';
import i18n, { i18n_t } from '@/locales/i18n';
export default defineComponent({
  name: 'SelectActionSheet',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: i18n_t('所属行业'),
    },
    options: {
      type: Array as () => Array<{
        label: string;
        value: string;
      }>,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
  },
  components: {
    ActionSheet,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innershow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const methods = {
      onClick(item: { label: string; value: string }) {
        context.emit('change', item.value);
      },
      onClose() {
        innershow.value = false;
      },
    };
    return {
      innershow,
      ...methods,
    };
  },
});
